import { fetchAllStoresAction, fetchStoreInfoAction, setStoresCache } from './action'
import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

type Nullable<T> = T | null

type PlainInfo<T> = {
  status: RequestState
  error?: string
  data: Nullable<T>
}

type RequestState = 'pending' | 'fulfilled' | 'rejected' | 'none'

const initialState: PlainInfo<Oms.V4.Store[]> = {
  status: 'none',
  data: [],
  error: null
}

export const storesSlice = createSlice({
  name: '@stores',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllStoresAction.pending, (state) => {
        state.status = 'pending'
      })
      .addCase(fetchAllStoresAction.fulfilled, (state, action) => {
        state.status = 'fulfilled'
        state.data = action.payload?.payload?.stores
      })
      .addCase(fetchAllStoresAction.rejected, (state, action) => {
        state.status = 'rejected'
        state.error = action.error.message
      })
      .addCase(fetchStoreInfoAction.pending, (state) => {
        state.status = 'pending'
      })
      .addCase(fetchStoreInfoAction.fulfilled, (state, action) => {
        state.status = 'fulfilled'
        const store = action.payload.payload.stores[0]
        state.data = state.data.map((currStore) =>
          currStore.id === store.id
            ? {
                ...currStore,
                earliestCollectionDate: store.earliestCollectionDate,
                earliestCollectionEndTime: store.earliestCollectionEndTime,
                earliestCollectionTime: store.earliestCollectionTime,
                earliestCollectionTimeStamp: store.earliestCollectionTimeStamp
              }
            : currStore
        )
      })
      .addCase(fetchStoreInfoAction.rejected, (state, action) => {
        state.status = 'rejected'
        state.error = action.error.message
      })
      .addCase(setStoresCache, (state, action) => {
        state.status = action.payload.status
        state.data = action.payload.data
      })
      .addCase(HYDRATE, (state, action) => ({
        ...state,
        ...action['payload']['@stores']
      }))
  }
})
